import React, { useEffect, useState } from "react";
import CardDiv from "modules/common/card-div/CardDiv";
import { Button } from "react-bootstrap";
import { Drawer, Table } from "antd";
import { useCallingIncentives } from "./store";
import CallingIncentiveFilter from "./CallingIncentiveFilter";
import moment from "moment";

const CallingIncentives = () => {
  const [visible, setVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [triggerFetch, setTriggerFetch] = useState(true);

  const getTodayDate = () => {
    const todayDate = moment().format("YYYY-MM-DD");
    return todayDate;
  };

  //state to handle queryparams
  const [queryParam, setQueryParam] = useState({
    pageSize: pageSize,
    pageNumber: currentPage,
    empType: "",
    incentiveMonthDate: getTodayDate(),
  });

  const [filterQueryParams, setFilterQueryParams] = useState({
    empType: "",
  });

  const {
    callingIncentivesData,
    fetchCallingIncentivesData,
    fetchCallingIncentivesFilters,
    callingIncentivesFilterData,
  } = useCallingIncentives();

  //Changing parameters to query parameters
  const buildQueryString = (data) => {
    const params = new URLSearchParams();
    for (const key in data) {
      if (Array.isArray(data[key])) {
        params.append(
          key,
          `[${data[key].map((value) => `'${value}'`).join(",")}]`
        );
      } else if (data[key] !== undefined && data[key] !== "") {
        params.append(key, data[key]);
      }
    }
    return `?${params.toString()}`;
  };

  //func to convert params as JSON.stringify
  const filterAndTransformParams = (params) => {
    return Object.fromEntries(
      Object.entries(params).filter(([key, value]) =>
        Array.isArray(value) ? value.length > 0 : value
      )
    );
  };
  useEffect(() => {
    if (callingIncentivesFilterData && callingIncentivesFilterData.filters) {
      const empTypeFilter = callingIncentivesFilterData.filters.find(
        (filter) => filter.filter_code === "empType"
      );
      if (empTypeFilter && empTypeFilter.default_filter_value) {
        setQueryParam((prevState) => ({
          ...prevState,
          empType: empTypeFilter.default_filter_value,
        }));
      }
    }
  }, [callingIncentivesFilterData]);

  //load on initial mount
  useEffect(() => {
    const updatedFilters = filterAndTransformParams(filterQueryParams);
    const queryString = buildQueryString(updatedFilters);
    fetchCallingIncentivesFilters(queryString);
  }, [filterQueryParams]);

  //load Table data
  useEffect(() => {
    if (queryParam.empType !== "") {
      const updatedFilters = filterAndTransformParams(queryParam);
      const queryString = buildQueryString(updatedFilters);
      fetchCallingIncentivesData(queryString);
    }
  }, [queryParam]);

  //After Applying filter
  const handleApplyFilters = (filters) => {
    let updatedFilters = { ...filters };

    const mergedFilters = {
      ...queryParam,
      ...updatedFilters,
      pageSize: 10,
      pageNumber: 1,
    };

    const finalFilters = filterAndTransformParams(mergedFilters);
    setQueryParam(finalFilters);
    setTriggerFetch(true);
    setCurrentPage(1);
    setPageSize(10);
    setVisible(!visible);
  };

  //Pagination
  const handleTableChange = (pagination) => {
    const updatedPagination = {
      ...queryParam,
      pageSize: pagination.pageSize,
      pageNumber: pagination.current,
    };
    setPageSize(pagination.pageSize);
    setCurrentPage(pagination.current);
    setQueryParam(updatedPagination);
    setTriggerFetch(true);
  };

  return (
    <>
      <CardDiv
        title={"Calling Incentives Dashboard"}
        component={
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 10,
              }}
            >
              <Button
                type="primary"
                onClick={() => setVisible(true)}
                shape="round"
                style={{ marginRight: 10 }}
              >
                Filter
              </Button>
              <Drawer
                title="Filter for Calling Incentives"
                placement="right"
                onClose={() => setVisible(false)}
                visible={visible}
                width="30%"
                zIndex={999999999}
              >
                <CallingIncentiveFilter
                  onApplyFilters={handleApplyFilters}
                  onClose={() => setVisible(!visible)}
                  setQueryParam={setQueryParam}
                  setCurrentPage={setCurrentPage}
                  setPageSize={setPageSize}
                  setTriggerFetch={setTriggerFetch}
                  filterAndTransformParams={filterAndTransformParams}
                  buildQueryString={buildQueryString}
                  setFilterQueryParams={setFilterQueryParams}
                />
              </Drawer>
              <span className="shadow p-2 text-nowrap text-center">
                Results: {callingIncentivesData.total_row_count}
              </span>{" "}
            </div>

            <div className="table-responsive">
              <Table
                columns={callingIncentivesData.headers}
                dataSource={callingIncentivesData.rows_data}
                onChange={handleTableChange}
                bordered
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  total: callingIncentivesData.total_row_count,
                  showSizeChanger: true,
                }}
                scroll={{ x: "max-content" }}
                
              />
            </div>
          </>
        }
      />
    </>
  );
};

export default CallingIncentives;
